import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {FlowPickState} from '@gongxigames/framework/slot/modules/flow/states/FlowPickState';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import { BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow/FlowModule';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';

export class FlowFreeGamesPickState extends FlowPickState {
    protected setupEvents(): void {
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOut.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupFadeOut(type: symbol): void {
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.setupFreeSpinsFinished();
        }
    }

    protected checkRestore(): void {
        if (this.module.isRestore) {
            this.emit(FlowModuleEvents.PICK_GAME_RESTORED, true);
        }
    }

    protected setupFreeSpinsFinished(): void {
        if (this.isBigWinAfterFreeGamesFinished()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_FREE_SPINS_STARTED);
            this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.setupWinAfterFreeSpins.bind(this));
        } else {
            this.setupWinAfterFreeSpins();
        }

        this.emit(ReelsEvents.ENABLE_SPIN_BY_SPIN_BUTTON);
        this.emit(FlowModuleEvents.CAN_SPIN);
    }

    protected setupWinAfterFreeSpins(): void {
        this.module.gotoState(FlowModule.BASIC_STATE);
        this.restoreFreeSpinsWinningRoundWinPresentation();
    }

    protected setupPickBonusFinished(): void {
        this.emit('General.UI.ENABLE', UIDisableReason.TRIGGERING_FEATURE);
        this.checkFreeSpinsState();
    }

    protected checkFreeSpinsState(): void {
        if (this.isLastFreeSpin()) {
            this.setupWinInLastFreeSpin();
        } else {
            if (this.isRetriggerWon()) {
                this.setupRetrigger();
            } else {
                this.setupWin();
            }
        }
    }

    protected setupRetrigger(): void {
        const fsWon: number = this.module.logic.getRetriggerCount();

        this.emit(FlowModuleEvents.FREESPINS_RETRIGGER_WIN, fsWon);
        this.addCallbackToWaitingLIst(GenericPopupEvents.POPUP_CLOSED, this.setupWin);
    }

    protected setupWinInLastFreeSpin(): void {
        const eventToFire = this.isWin() ? FlowModuleEvents.WP_RESTORE : FlowModuleEvents.FREE_SPINS_FINISHED;

        if (this.isBigWinInCurrentRound()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_BONUS_GAME_STARTED);
            this.addEventToWaitingList(BigWinEvents.FINISHED, eventToFire);
        } else {
            this.emit(eventToFire);
        }

        if (this.isWin()) {
            this.emit(ReelsEvents.DISABLE_SPIN_BY_SPIN_BUTTON);
            this.addEventToWaitingList(SpinButtonEvents.SPIN_BUTTON_PRESSED, FlowModuleEvents.FREE_SPINS_FINISHED);
            this.addEventToWaitingList(WinPresentationEvents.ALL_PAY_ANIMATIONS_FINISHED, FlowModuleEvents.FREE_SPINS_FINISHED);
            this.addEventToWaitingList(WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED,
                FlowModuleEvents.FREE_SPINS_FINISHED);
        }
    }

    protected setupWin(): void {
        this.emit(FlowModuleEvents.START_PICK_BONUS_AWARD);

        if (this.isBigWinInCurrentRound()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_BONUS_GAME_STARTED);
            this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.setupWinAfterPickBonus.bind(this));
        } else {
            this.setupWinAfterPickBonus();
        }
    }

    protected setupWinAfterPickBonus(): void {
        this.emit(ReelsEvents.DISABLE_SPIN_BY_SPIN_BUTTON);
        this.emit(FlowModuleEvents.WP_RESTORE);

        if (this.isWin()) {
            this.addCallbackToWaitingLIst(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onRoundCompleted.bind(this));
            this.addCallbackToWaitingLIst(WinPresentationEvents.PAY_ANIMATIONS_AND_WIN_METER_FINISHED,
                this.onRoundCompleted.bind(this));
        } else {
            this.onRoundCompleted();
        }
    }

    protected onRoundCompleted(): void {
        if (this.module.isRestore) {
            this.module.isRestore = false;
        }

        this.clearEventsQueue();
        this.emit(ReelsEvents.ENABLE_SPIN_BY_SPIN_BUTTON);
        this.emit(FlowModuleEvents.CAN_SPIN);
        this.module.gotoState(FlowModule.FREE_SPINS_STATE);
    }

    protected isBigWinAfterFreeGamesFinished(): boolean {
        return this.module.logic.isBigTotalWin();
    }

    protected isLastFreeSpin(): boolean {
        return this.module.logic.getFreeGamesCount() === 0 && this.module.logic.spinData.action === Action.FREESPIN;
    }

    protected restoreFreeSpinsWinningRoundWinPresentation(): void {
        this.emit(FlowModuleEvents.WP_RESTORE, this.module.logic.getSessionForFreeSpinsWinningRound());
    }

    protected isRetriggerWon(): boolean {
        return false; // Should be overridden if need
    }
}
